<template>
    <svg
        width="660"
        height="285"
        viewBox="0 0 660 285"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            x="287"
            y="58"
            font-family="Inter"
            font-weight="700"
            font-size="34"
            fill="var(--et-colors-text)"
        >
            FAQs
        </text>
        <text
            x="220"
            y="95"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Can not find answer? Contact us
        </text>
        <path
            d="M373.367 99H451.128V99.8H373.367V99Z"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        />
        <g>
            <g>
                <rect
                    x="33"
                    y="129"
                    width="293"
                    height="120"
                    rx="12"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="57"
                    y="169"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Will I receive a VAT invoice?
                </text>

                <rect
                    x="57"
                    y="183"
                    width="245"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="57"
                    y="199"
                    width="184"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="57"
                    y="215"
                    width="87"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="334"
                    y="129"
                    width="293"
                    height="120"
                    rx="12"
                    fill="var(--et-colors-card-background)"
                />
                <text
                    x="357"
                    y="169"
                    font-family="Inter"
                    font-weight="600"
                    font-size="14"
                    fill="var(--et-colors-card-text)"
                >
                    Can I return the purchased product?
                </text>
                <rect
                    x="358"
                    y="183"
                    width="245"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="358"
                    y="199"
                    width="210"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
                <rect
                    x="358"
                    y="215"
                    width="221"
                    height="10"
                    rx="5"
                    fill="var(--et-colors-card-text)"
                    fill-opacity="0.15"
                />
            </g>
            <path
                d="M645 195L651 189L645 183"
                stroke="var(--et-colors-text)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15 183L9 189L15 195"
                stroke="var(--et-colors-text)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
</template>
